import RoutesMap from "../route_control/RouteControl";
import { toast } from "react-toastify";
import showAccessDeniedAlert from "./accessDenied";
import SessionManager from "./sessionManager";

const addUpdateHandler = (data) => {

    const { res, action, navigate, success_toast, wrong_toast, navigate_route, spinner, toggle } = data;

    const resetSubmitState = () => {
        if (typeof spinner === 'function') spinner(false);
        action?.setSubmitting?.(false);
    };

    if (res?.status === 201) {
        toast.success(success_toast, { position: "bottom-right", closeOnClick: true });
        resetSubmitState();
        action?.resetForm()
        if (navigate_route === '') {
            toggle();
        } else {
            setTimeout(() => {
                navigate(navigate_route);
            }, 1500);
        }
    } else if (res?.status === 200) {
        toast.success(success_toast, { position: "bottom-right", closeOnClick: true });
        resetSubmitState();
        if (navigate_route === '') {
            toggle();
        } else {
            setTimeout(() => {
                navigate(navigate_route);
            }, 1500);
        }
    } else if (res?.status === 401) {
        SessionManager.removeCookie("user_token");
        resetSubmitState();
        navigate(RoutesMap.LOGIN.path);
    } else if (res?.status === 400) {
        toast.error(res?.data?.message, { position: "bottom-right", closeOnClick: true });
        resetSubmitState();
    } else if (res?.status === 403) {
        showAccessDeniedAlert(navigate)
        resetSubmitState();
    } else {
        toast.error(wrong_toast, { position: "bottom-right", closeOnClick: true });
        resetSubmitState();
    }
};

export default addUpdateHandler;
